import api from './api';

/**
 * سرویس مدیریت کاربران
 * شامل CRUD عملیات برای کاربران
 */

// دریافت لیست کاربران
export const getUsers = async (params = {}) => {
  try {
    const response = await api.get('/users', { params });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// جستجو در کاربران
export const searchUsers = async (searchTerm) => {
  try {
    const response = await api.get('/users', { 
      params: { search: searchTerm, limit: 100 } 
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// دریافت اطلاعات یک کاربر خاص
export const getUserById = async (userId) => {
  try {
    const response = await api.get(`/users/${userId}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// ایجاد کاربر جدید
export const createUser = async (userData) => {
  try {
    const response = await api.post('/users', userData);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// بروزرسانی کاربر
export const updateUser = async ({ userId, userData }) => {
  try {
    // اطمینان از اینکه userId یک string معتبر است
    const userIdString = String(userId).trim();
    
    if (!userIdString || userIdString === 'undefined' || userIdString === 'null') {
      throw new Error('شناسه کاربر نامعتبر است');
    }
    
    const response = await api.put(`/users/${userIdString}`, userData);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// تغییر وضعیت کاربر
export const toggleUserStatus = async (userId) => {
  try {
    const response = await api.put(`/users/${userId}/status`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// حذف کاربر (soft delete)
export const deleteUser = async (userId) => {
  try {
    const response = await api.delete(`/users/${userId}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// دریافت لیست مشاوران
export const getConsultants = async () => {
  try {
    const response = await api.get('/users/consultants');
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
}; 